// libs
import React from 'react';
import PropTypes from 'prop-types';

function SearchTag(props) {
  const {
    filterLabels,
    formValues,
    tag,
    updateFormValues,
  } = props;
  const currentFilter = filterLabels.filter(({ slug }) => tag === slug);
  const label = (typeof formValues[tag] === 'boolean' && currentFilter.length !== 0) ?
    currentFilter[0].name : formValues[tag];
  return (
    <li className="filters__active-filters__item" key={`tag-${tag}`}>
      {label}
      <button className="filters__active-filters__button" type="button" onClick={() => updateFormValues(tag)} />
    </li>
  );
}

SearchTag.contextTypes = {};

SearchTag.propTypes = {
  filterLabels: PropTypes.array.isRequired,
  formValues: PropTypes.object.isRequired,
  tag: PropTypes.string.isRequired,
  updateFormValues: PropTypes.func.isRequired,
};

export default SearchTag;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchTag.js